import React from "react";
interface VariationOptionLabelProps {
  uniqueCounts: {
    name: string;
    count: number | undefined;
  }[];
  numberOfUniqueOptions: number;
  wrapperClass: string;
  overrideMap: {
    [key: string]: string;
  };
  shouldDisplayOptionText: boolean;
  optionTextWrapperClass: string;
}
const VariationOptionLabel: React.FC<VariationOptionLabelProps> = ({
  uniqueCounts,
  numberOfUniqueOptions,
  wrapperClass,
  overrideMap,
  shouldDisplayOptionText,
  optionTextWrapperClass
}) => {
  return <>
      {shouldDisplayOptionText ? <span className={optionTextWrapperClass} data-testid="option-text">
          {numberOfUniqueOptions}{" "}
          {numberOfUniqueOptions > 1 ? "Options" : "Option"}
        </span> : uniqueCounts.map(({
      name,
      count
    }) => <span key={`${name}_${count}`} className={wrapperClass} data-testid="option-text">
            {`${count} ${overrideMap[name] ?? name}${overrideMap[name]?.endsWith("s") ? "" : "s"}`}
          </span>)}
    </>;
};
export default React.memo(VariationOptionLabel);